export const GET_CAREGIVER_PROFILE = 'GET_CAREGIVER_PROFILE';
export const GET_CLIENT_PROFILE = 'GET_CLIENT_PROFILE';
export const GET_BANK_DETAILS = 'GET_BANK_DETAILS';
export const SAVE_ALL_NOTIFICATIONS = "SAVE_ALL_NOTIFICATIONS";